<template>
  <div>
    <h2 class="my-3 text-center text-primary text-capitalize">
      <strong>invite users</strong>
    </h2>
    <users-invite-form
      :user="user"
      :submit="inviteUser"
    />
  </div>
</template>

<script>
import UsersInviteForm from '@/components/TeamManagement/Users/UsersInviteForm.vue'
import Users from '@/compositions/TeamManagement/Users/UsersAPI'
import handleAlerts from '@/compositions/common/handleAlerts'

export default {
  name: 'UserInvite',
  components: { UsersInviteForm },
  setup() {
    const { successfulOperationAlert } = handleAlerts()
    const { user, inviteRequest } = Users()
    return { user, inviteRequest, successfulOperationAlert }
  },
  methods: {
    inviteUser() {
      return this.inviteRequest(this.$orgId).then(() => {
        this.successfulOperationAlert('User is invited successfully')
        this.$router.back()
      })
    },
  },
}
</script>

<style>

</style>
